"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _toConsumableArray = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.reduce");

var _classCallCheck = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _possibleConstructorReturn = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_1 = require("./styled");
/**
 * Accordion component
 */


var Accordion = /*#__PURE__*/function (_react_1$PureComponen) {
  _inherits(Accordion, _react_1$PureComponen);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);

    _this.componentDidMount = function () {
      var items = _this.props.items;
      var opened = items.reduce(function (p, c, i) {
        if (c.expanded) return [].concat(_toConsumableArray(p), [i]);
        return p;
      }, []);
      setTimeout(function () {
        return _this.setState({
          opened: opened
        });
      }, 100);
    };

    _this.setTextRef = function (e, i) {
      _this.textsRefs[i] = e;
    };

    _this.toggleItem = function (index) {
      var single = _this.props.singleOpen;
      var opened = _this.state.opened;

      var newOpened = _toConsumableArray(opened);

      if (single) return _this.setState({
        opened: index === opened[0] ? [] : [index]
      });

      if (opened.includes(index)) {
        newOpened = newOpened.filter(function (i) {
          return i !== index;
        });
      } else {
        newOpened.push(index);
      }

      return _this.setState({
        opened: newOpened
      });
    };

    _this.render = function () {
      var _a = _this.props,
          items = _a.items,
          icons = _a.icons,
          rest = __rest(_a, ["items", "icons"]);

      var opened = _this.state.opened;
      return react_1["default"].createElement("div", Object.assign({}, rest), items.map(function (item, index) {
        var _a, _b;

        var openedIcon = item.icons ? item.icons.opened : (_a = icons) === null || _a === void 0 ? void 0 : _a.opened;
        var closedIcon = item.icons ? item.icons.closed : (_b = icons) === null || _b === void 0 ? void 0 : _b.closed;
        return (
          /* eslint-disable-next-line react/no-array-index-key */
          react_1["default"].createElement(styled_1.Item, {
            key: index
          }, react_1["default"].createElement(styled_1.Title, {
            type: "button",
            expanded: item.expanded || opened.includes(index),
            onClick: function onClick() {
              if (item.expanded) return;

              _this.toggleItem(index);
            }
          }, item.title, opened.includes(index) ? openedIcon : closedIcon), react_1["default"].createElement(styled_1.Content, {
            expanded: item.expanded || opened.includes(index),
            style: {
              height: opened.includes(index) && _this.textsRefs[index] ? _this.textsRefs[index].offsetHeight : 0
            }
          }, react_1["default"].createElement(styled_1.Text, {
            ref: function ref(e) {
              return _this.setTextRef(e, index);
            }
          }, item.content)))
        );
      }));
    };

    _this.state = {
      opened: []
    };
    _this.textsRefs = [];
    _this.toggleItem = _this.toggleItem.bind(_assertThisInitialized(_this));
    _this.setTextRef = _this.setTextRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  return Accordion;
}(react_1.PureComponent);

exports["default"] = Accordion;